// removed by extract-text-webpack-plugin
module.exports = {"backgrounds":"nrk-backgrounds","background":"nrk-background","visible":"nrk-visible","superoverlay":"nrk-superoverlay","backgroundGradient":"nrk-backgroundGradient"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/stylesheets/background.css
// module id = 11
// module chunks = 0